import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-customer-machine-summary-report',
  templateUrl: './customer-machine-summary-report.component.html',
  styleUrls: ['../customer-active-inactive-report/customer-active-inactive-report.component.scss']
})
export class CustomerMachineSummaryReportComponent implements OnInit {
  loading: boolean = true;
  orgId: any;
  userId: any;
  p: number = 1;
  search: any;
  selectedCustomerDetails: any;
  allRows: any[] = [];
  filteredRows: any[] = [];
  summary = {
    qty: 0,
    active: 0,
    inactive: 0,
    expired: 0,
  };

  constructor(private http: Http, private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null) {
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
      return;
    }

    this.orgId = this.route.params['value'].orgId;
    this.userId = this.route.params['value'].userId;
    this.loadReport();
  }

  loadReport() {
    this.loading = true;
    const reportObj = {
      orgId: this.orgId
    };

    return this.http.post('/api/getCustomerMachineSummaryReport', reportObj).subscribe(
      (res: any) => {
        const response = res.json() || [];
        this.allRows = [];
        this.summary = {
          qty: 0,
          active: 0,
          inactive: 0,
          expired: 0,
        };

        for (let index = 0; index < response.length; index++) {
          const row = response[index] || {};
          const reportRow = {
            customerName: row.customer_Name || '',
            phoneNumber: row.phone_Number || '',
            landlineNumber: row.landline_Number || '',
            contactName: row.ContactName || '',
            department: row.Department || '',
            contactNumber: row.ContactNumber || '',
            email: row.Email || '',
            qty: Number(row.qty || 0),
            active: Number(row.active || 0),
            inactive: Number(row.inactive || 0),
            expired: Number(row.expired || 0),
          };

          this.summary.qty += reportRow.qty;
          this.summary.active += reportRow.active;
          this.summary.inactive += reportRow.inactive;
          this.summary.expired += reportRow.expired;
          this.allRows.push(reportRow);
        }

        this.filteredRows = this.allRows.slice();
        this.p = 1;
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('unable to load customer machine summary report');
      }
    );
  }

  exportToExcel() {
    if (this.filteredRows.length <= 0) {
      alert('no records available to export');
      return;
    }

    let data = [];
    let title = 'Customer Machine Summary Report.xlsx';
    data.push(['Customer Machine Summary Report']);
    data.push([]);
    data.push(['S NO', 'CUSTOMER NAME', 'QTY', 'ACTIVE', 'INACTIVE', 'EXPIRED']);

    for (let index = 0; index < this.filteredRows.length; index++) {
      data.push([
        index + 1,
        this.filteredRows[index].customerName,
        this.filteredRows[index].qty,
        this.filteredRows[index].active || '',
        this.filteredRows[index].inactive || '',
        this.filteredRows[index].expired || '',
      ]);
    }

    let wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Customer Summary');
    XLSX.writeFile(wb, title);
  }

  openCustomerDetails(row: any) {
    this.selectedCustomerDetails = row;
  }

  closeCustomerDetails() {
    this.selectedCustomerDetails = null;
  }
}


// WEBPACK FOOTER //
// ./client/app/customer-machine-summary-report/customer-machine-summary-report.component.ts